import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import firebase from "firebase";

Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    redirect: "home",
  },
  // {
  //   path: "/signin",
  //   name: "Signin",
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../components/Signin.vue"),
  // },
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      requiresAuth: false,
      title: "",
      desc:
        "",
    },
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
    meta: {
      requiresAuth: false,
      title: "",
      desc:
        "",
    },
  },
  {
    path: "/about",
    name: "About",
    component: () =>
      import("../views/About.vue"),
    meta: {
      requiresAuth: false,
      title: "本サークルについて",
      desc:
        "点字サークル「杉」は埼玉県杉戸町の点字ボランティアサークルです。書籍の点訳などを行っています。",
      noindex: true,
    },
  },
  {
    path: "/histry",
    name: "Histry",
    component: () =>
      import("../views/Histry.vue"),
    meta: {
      requiresAuth: false,
      title: "これまでのあゆみ",
      desc:
        "点字サークル「杉」の1992年から現在までのあゆみをご紹介致します",
      noindex: true,
    },
  },
  {
    path: "/library",
    name: "Library",
    component: () =>
      import("../views/Library.vue"),
    meta: {
      requiresAuth: false,
      title: "点訳図書",
      desc:
        "点字サークル「杉」が点訳した100冊以上の点訳データをどなたでもダウンロードできます。",
      noindex: false,
    },
  },
  {
    path: "/request",
    name: "Request",
    component: () =>
      import("../views/Request.vue"),
    meta: {
      requiresAuth: false,
      title: "点訳依頼",
      desc:
        "点字サークル「杉」への点訳依頼についてのご説明です。",
      noindex: true,
    },
  },
  {
    path: "/photo",
    name: "Photo",
    component: () =>
      import("../views/Photo.vue"),
    meta: {
      requiresAuth: false,
      title: "活動写真",
      desc:
        "点字サークル「杉」の活動内容を写真でご紹介いたします。",
      noindex: true,
    },
  },
  {
    path: "/mail",
    name: "Mail",
    component: () =>
      import("../views/Mail.vue"),
    meta: {
      requiresAuth: false,
      title: "お問い合わせ",
      desc:
        "点字サークル「杉」への点訳依頼やお問い合わせはこちらから。",
      noindex: true,
    },
  },
  // {
  //   path: "/news",
  //   name: "News",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/News.vue"),
  //   meta: { requiresAuth: true },
  // },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  if (requiresAuth) {
    // このルートはログインされているかどうか認証が必要です。
    // もしされていないならば、ログインページにリダイレクトします。
    firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
        next();
      } else {
        next({
          path: "/signin",
          query: { redirect: to.fullPath },
        });
      }
    });
  } else {
    next(); // next() を常に呼び出すようにしてください!
  }
});

export default router;
